import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      // main: "#E61E28",
      main: "#037FB0"
    },
    secondary: {
      main: "#000000",
    },
    background: {
      default: "#F2F2F2",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minWidth: 0,
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          expandIcon: {
            transform: "rotate(90deg)",
          },
        },
      },
    },
  },
});
